import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import usePersonStore from '../../store/personStore';

export const MenuBar = ({ hasOnlyDriversRole }) => {
  const [active, setActive] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  const isLoyaltyEligible = usePersonStore((store) => store.isLoyaltyEligible);
  const isLoyaltyEnrolled = usePersonStore((store) => store.isLoyaltyEnrolled);
  

  useEffect(() => {
    if (location) {
      const final = location.pathname.split('/');
      const current = final[1];
      setActive(current);
    }
  }, [location]);

  return (
    <div
      className={"w-full flex py-4 px-5 lg:px-20 bg-[#F5F5F7] justify-center sticky"}
      style={{
        boxShadow: '0px -8px 10px 0px #0000000D',
      }}
    >
      <div className="flex justify-center max-lg:w-full gap-3 lg:gap-6">
        <Button
          onClick={() => {
            navigate('/dashboard');
          }}
          className={clsx(
            'lg:h6 text-label py-2 px-4 rounded-full ',
            active === 'dashboard' ? 'bg-midgrey text-white' : 'bg-white '
          )}
        >
          My Cars
        </Button>
        {!hasOnlyDriversRole && (
          <Button
            onClick={() => {
              navigate('/invoices');
            }}
            className={clsx(
              'lg:h6 text-label py-2 px-4 rounded-full',
              active === 'invoices' ? 'bg-midgrey text-white' : 'bg-white '
            )}
          >
            Τιμολόγια
          </Button>
        )}
        {!hasOnlyDriversRole && (
          <Button
            onClick={() => {
              navigate('/reports');
            }}
            className={clsx(
              'lg:h6 text-label py-2 px-4 rounded-full',
              active === 'reports' ? 'bg-midgrey text-white' : 'bg-white '
            )}
          >
            Αναφορές
          </Button>
        )}
        <Button
          onClick={() => {
            navigate('/portal/documents');
          }}
          className={clsx(
            'lg:h6 text-label py-2 px-4 rounded-full',
            location.pathname === '/portal/documents' ? 'bg-midgrey text-white' : 'bg-white '
          )}
        >
          Έγγραφα
        </Button>
        {isLoyaltyEligible && <Button
          onClick={() => {
            if(isLoyaltyEnrolled) {
              navigate('/portal/loyalty/profile');
            } else {
              navigate('/portal/loyalty/register');
            }
          }}
          className={clsx(
            'lg:h6 text-label py-2 px-4 rounded-full',
            location.pathname === '/portal/loyalty/register' ? 'bg-midgrey text-white' : 'bg-white '
          )}
        >
          Avis More
        </Button>}
        <Button
          onClick={() => {
            navigate('/faqs');
          }}
          className={clsx(
            'lg:h6 text-label py-2 px-4 rounded-full',
            active === 'faqs' ? 'bg-midgrey text-white' : 'bg-white '
          )}
        >
          Κέντρο Υποστήριξης
        </Button>
      </div>
    </div>
  );
};
